// eslint-disable-next-line import/prefer-default-export
export const AgreementsActionTypes = {
  SET_TERMS_AND_CONDITIONS: 'SET_TERMS_AND_CONDITIONS',
  SET_ADDRESS_INDICATED: 'SET_ADDRESS_INDICATED'
};
